import { defineComponent as _defineComponent } from 'vue'
import { useRoute } from 'vue-router/composables';
import { computed } from 'vue';
import { TagDto } from '@/api';
import { getProviderIconSrc } from '@/utils/provider-icons';
import SEllipsisToolTip from '@/components/SEllipsisTooltip/SEllipsisTooltip.vue';
import SIcon from '@/components/SIcon.vue';

interface TagProps {
  tag: TagDto;
  showTooltip?: boolean;
  filter?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Tag',
  props: {
  tag: null,
  showTooltip: { type: Boolean, default: false },
  filter: { type: Boolean, default: false }
},
  setup(__props) {

const props = __props;



const route = useRoute();

const isClassification = computed(() => 'type' in props.tag && props.tag.type === TagDto.type.VISIBLE_DATA_CLASSIFICATION);
// Inherited external source/catalog tags are exactly the ones suffixed `_EXTERNAL`
const isInherited = computed(() => 'type' in props.tag && props.tag.type.endsWith('_EXTERNAL'));
const image = computed(() => {
  if ('type' in props.tag) {
    const providerKey = props.tag.type.replace(/_EXTERNAL$/, '');
    return getProviderIconSrc(`${providerKey}_LOCK`);
  }
  return '';
});
const isAssetOverview = computed(() => ['data-catalog.asset.overview', 'data-catalog.asset.lineage'].includes((route.name as string)));


return { __sfc: true,props, route, isClassification, isInherited, image, isAssetOverview, useRoute, computed, TagDto, getProviderIconSrc, SEllipsisToolTip, SIcon }
}

})